import API from './ApiBase';
import {
  ComplianceRecord,
  ComplianceRecordFinishResult,
  UpdateComplianceRecordPayload,
} from '../types/ComplianceRecord.types';

const base = (aiSystemId: string) => `/compliance-record/ai-systems/${aiSystemId}`;

/** Get-or-create the draft compliance record for an AI system. */
export const createComplianceRecord = async (
  aiSystemId: string,
): Promise<ComplianceRecord> => {
  const response = await API.post<ComplianceRecord>(base(aiSystemId));
  return response.data;
};

export const getComplianceRecord = async (
  aiSystemId: string,
): Promise<ComplianceRecord> => {
  const response = await API.get<ComplianceRecord>(base(aiSystemId));
  return response.data;
};

export const updateComplianceRecord = async (
  aiSystemId: string,
  payload: UpdateComplianceRecordPayload,
): Promise<ComplianceRecord> => {
  const response = await API.put<ComplianceRecord>(base(aiSystemId), payload);
  return response.data;
};

/**
 * Validate & submit the record. With SignatureAPI on this returns
 * `{ requiresSignature: true }` and the caller then calls `signDocument`;
 * otherwise the record is finalized server-side.
 */
export const completeComplianceRecord = async (
  aiSystemId: string,
  payload: UpdateComplianceRecordPayload,
): Promise<ComplianceRecordFinishResult> => {
  const response = await API.put<ComplianceRecordFinishResult>(
    `${base(aiSystemId)}/complete`,
    payload,
  );
  return response.data;
};
